import React from "react";
import Modal from "./modals/Modal.jsx";
import EventsTable from "./events/EventsTable.jsx";
import Button from "./ui/Button.jsx";

const DateBox = ({ dayObj, today, onClick, events = [] }) => {
    const { date, inCurrentMonth } = dayObj;
    const dayNumber = date.format("D");
    const isToday = date.isSame(today, "day");
    const hasEvent = events.length > 0;

    return (
        <div className="relative w-full flex items-center justify-center ">
            <Modal>
                <Modal.Open opens="events-list">
                    <Button   size="small"
                        onClick={() => onClick(date)}
                        className={`flex items-center justify-center w-8 h-8
                            transition text-center rounded-8
                            ${hasEvent ? "!bg-yellow-400" : "!bg-pink-200"}
                            ${isToday ? "!bg-pink-400 shadow underline border-2" : "!bg-pink-200 "}
                           
                            hover:bg-gray-200
                        `}
                    >
                        <span className="text-xs font-medium">{dayNumber}</span>
                    </Button>
                </Modal.Open>
                
                <Modal.Window name="events-list">
                    <EventsTable events={events}/>
                </Modal.Window>
            </Modal>
        </div>
    );
};

export default DateBox;
